import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { navigate } from '../router';
import { stytch } from '../auth/session.ts';
import { LitPage } from '../components/lit-page.ts';

import '../components/luna-auth-card/luna-auth-card';
import '../components/luna-button/luna-button';

@customElement('app-magic-link')
export class AppMagicLink extends LitPage {
  @state() private email = '';
  @state() private busy = false;
  @state() private errorMessage = '';
  @state() private noticeMessage = '';

  private async onSubmit(e: Event) {
    e.preventDefault();
    if (this.busy) return;
    this.busy = true;
    this.errorMessage = '';
    this.noticeMessage = '';
    try {
      await stytch.magicLinks.email.loginOrCreate(this.email, {
        login_magic_link_url: `${window.location.origin}/auth/callback`,
        login_expiration_minutes: 60,
        signup_magic_link_url: `${window.location.origin}/auth/callback`,
        signup_expiration_minutes: 60,
      });
      this.noticeMessage = `We've emailed a sign-in link to ${this.email}.`;
    } catch {
      this.errorMessage = 'We couldn\'t send the email. Please try again.';
    } finally {
      this.busy = false;
    }
  }

  content() {
    return html`
      <luna-auth-card>
        <h1 class="mbw-type-title-section">Sign in by email</h1>
        <p>
          Enter your email address and we'll send you a link that signs you in — no password
          needed.
        </p>

        <div class="auth-error" role="alert" ?hidden=${!this.errorMessage}>
          ${this.errorMessage}
        </div>
        <div class="auth-notice" role="status" ?hidden=${!this.noticeMessage}>
          ${this.noticeMessage}
        </div>

        <form @submit=${this.onSubmit}>
          <div>
            <label for="magic-email">Email address</label>
            <input
              id="magic-email"
              type="email"
              autocomplete="email"
              required
              .value=${this.email}
              @input=${(e: Event) => { this.email = (e.target as HTMLInputElement).value; }}
            />
          </div>

          <button type="submit" class="auth-submit-ghost" tabindex="-1" aria-hidden="true">
            Send sign-in link
          </button>
          <luna-button full ?disabled=${this.busy} @click=${this.onSubmit}>
            <span>${this.busy ? 'Sending…' : 'Send sign-in link'}</span>
          </luna-button>
        </form>

        <div class="auth-links">
          <button class="auth-link" type="button" @click=${() => navigate('/login')}>
            Back to sign in
          </button>
        </div>
      </luna-auth-card>
    `;
  }
}
